import { create } from 'zustand';

export type ThemePref = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

const STORAGE_KEY = 'lumo-theme';
const media = typeof window !== 'undefined' ? window.matchMedia('(prefers-color-scheme: dark)') : null;

function readPref(): ThemePref {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch {
    /* приватный режим */
  }
  return 'system';
}

function resolve(pref: ThemePref): ResolvedTheme {
  if (pref === 'system') return media?.matches ? 'dark' : 'light';
  return pref;
}

function apply(theme: ResolvedTheme): void {
  const root = document.documentElement;
  root.classList.toggle('dark', theme === 'dark');
  root.style.colorScheme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? '#1A1918' : '#FAF8F5');
}

interface ThemeState {
  pref: ThemePref;
  resolved: ResolvedTheme;
  setPref: (pref: ThemePref) => void;
}

export const useTheme = create<ThemeState>((set) => {
  const pref = readPref();
  const resolved = resolve(pref);
  media?.addEventListener('change', () => {
    const { pref: p } = useTheme.getState();
    if (p !== 'system') return;
    const r = resolve(p);
    apply(r);
    set({ resolved: r });
  });
  return {
    pref,
    resolved,
    setPref: (next) => {
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch {
        /* ignore */
      }
      const r = resolve(next);
      apply(r);
      set({ pref: next, resolved: r });
    },
  };
});
